module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Transition_00107.787f1b57.png";